/* pq-bundle-builder.js — Pique bundle builder for Base Thermals.
   Client-side PREVIEW only; the real discount is a Shopify automatic discount
   applied at checkout. State is keyed per VARIANT, so a shopper can add e.g.
   one Medium and one Large of the same thermal. */
(function () {
  'use strict';

  const root = document.querySelector('[data-pq-bundle]');
  if (!root) return;

  const target = parseInt(root.dataset.target, 10) || 3;
  const discount = parseFloat(root.dataset.discount) || 0;
  const savingMode = root.dataset.savingMode || 'amount';
  const afterAdd = root.dataset.afterAdd || 'cart';
  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

  const tiles = [...root.querySelectorAll('[data-pq-bundle-item]')];
  const msgEl = root.querySelector('[data-pq-bundle-msg]');
  const tallyEl = root.querySelector('[data-pq-bundle-tally]');
  const track = root.querySelector('[data-pq-bundle-track]');
  const trackFill = track ? track.querySelector('i') : null;
  const progressEl = root.querySelector('.pq-bundle__progress');
  const linesEl = root.querySelector('[data-pq-bundle-lines]');
  const subtotalEl = root.querySelector('[data-pq-bundle-subtotal]');
  const saveEl = root.querySelector('[data-pq-bundle-save]');
  const saveRow = root.querySelector('.pq-bundle__totals-row--save');
  const totalEl = root.querySelector('[data-pq-bundle-total]');
  const badgeEl = root.querySelector('[data-pq-bundle-badge]');
  const submitBtns = [...document.querySelectorAll('[data-pq-bundle-submit]')];
  const bar = document.querySelector('[data-pq-bundle-bar]');
  const totalMobile = document.querySelector('[data-pq-bundle-total-mobile]');
  const metaEl = document.querySelector('[data-pq-bundle-meta]');

  /* state: variantId -> { qty, price, max, label } */
  const state = new Map();

  /* ---- Shopify-style money formatter (value in cents) ---- */
  function formatMoney(cents) {
    const value = cents / 100;
    function withCommas(num, decimals) {
      const parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return decimals ? parts.join('.') : parts[0];
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => {
      switch (key) {
        case 'amount': return withCommas(value, 2);
        case 'amount_no_decimals': return withCommas(value, 0);
        case 'amount_with_comma_separator': return withCommas(value, 2).replace(/,/g, '§').replace(/\./, ',').replace(/§/g, '.');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0).replace(/,/g, '.');
        default: return withCommas(value, 2);
      }
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  /* ---- per-tile setup ---- */
  tiles.forEach((tile) => {
    let variants = [];
    try {
      variants = JSON.parse(tile.querySelector('[data-pq-bundle-variants]').textContent);
    } catch (e) { return; }
    if (!variants.length) return;

    const select = tile.querySelector('[data-pq-bundle-variant]');
    const priceEl = tile.querySelector('[data-pq-bundle-tile-price]');
    const qtyEl = tile.querySelector('[data-pq-bundle-qty]');
    const productTitle = tile.dataset.title || '';
    const multi = variants.length > 1;

    function current() {
      if (!select) return variants.find((v) => v.available) || variants[0];
      if (select.value === '') return null; /* placeholder — nothing chosen yet */
      const id = parseInt(select.value, 10);
      return variants.find((v) => v.id === id) || null;
    }

    function refreshTile() {
      const v = current();
      if (priceEl) {
        if (v) {
          priceEl.textContent = formatMoney(v.price);
        } else {
          const prices = variants.map((vv) => vv.price);
          const min = Math.min.apply(null, prices);
          priceEl.textContent = (Math.max.apply(null, prices) > min ? 'From ' : '') + formatMoney(min);
        }
      }
      if (qtyEl) qtyEl.textContent = (v && state.get(v.id) && state.get(v.id).qty) || 0;
      const productQty = variants.reduce((n, vv) => n + ((state.get(vv.id) && state.get(vv.id).qty) || 0), 0);
      tile.classList.toggle('is-active', productQty > 0);
    }

    function nudge() {
      if (!select) return;
      select.classList.add('is-nudge');
      select.focus();
      setTimeout(() => select.classList.remove('is-nudge'), 1600);
    }

    if (select) select.addEventListener('change', refreshTile);

    const addBtn = tile.querySelector('[data-pq-bundle-add]');
    const subBtn = tile.querySelector('[data-pq-bundle-sub]');
    if (addBtn) addBtn.addEventListener('click', () => {
      const v = current();
      if (!v) return nudge();
      if (!v.available) return;
      const entry = state.get(v.id) || { qty: 0, price: v.price, max: v.max, label: multi ? productTitle + ' — ' + v.title : productTitle };
      if (entry.qty >= (isNaN(v.max) ? Infinity : v.max)) return;
      entry.qty += 1;
      state.set(v.id, entry);
      refreshTile();
      recompute();
    });
    if (subBtn) subBtn.addEventListener('click', () => {
      const v = current();
      if (!v) return;
      const entry = state.get(v.id);
      if (!entry) return;
      entry.qty = Math.max(0, entry.qty - 1);
      if (entry.qty === 0) state.delete(v.id); else state.set(v.id, entry);
      refreshTile();
      recompute();
    });

    tile._pqRefresh = refreshTile;
    refreshTile();
  });

  function recompute() {
    let totalQty = 0;
    let subtotal = 0;
    const lines = [];
    state.forEach((entry) => {
      if (entry.qty <= 0) return;
      totalQty += entry.qty;
      subtotal += entry.qty * entry.price;
      lines.push(entry);
    });

    const met = totalQty >= target;
    const save = met ? Math.round(subtotal * discount / 100) : 0;
    const totalPrice = subtotal - save;
    const remaining = Math.max(0, target - totalQty);
    const pct = Math.min(100, target ? (totalQty / target) * 100 : 0);

    if (trackFill) trackFill.style.width = pct + '%';
    if (track) track.classList.toggle('is-met', met);
    if (progressEl) progressEl.classList.toggle('is-met', met);
    if (tallyEl) tallyEl.textContent = totalQty + '/' + target;

    if (msgEl) {
      const savingText = savingMode === 'percent'
        ? discount + '% unlocked!'
        : 'you save ' + formatMoney(save);
      msgEl.textContent = met
        ? '✓ ' + totalQty + ' of ' + target + ' added — ' + savingText
        : 'Add ' + remaining + ' more to unlock ' + discount + '% off';
    }

    if (linesEl) {
      linesEl.innerHTML = lines.length
        ? lines.map((l) => '<div class="pq-bundle__line"><span>' + escapeHtml(l.label) + ' × ' + l.qty + '</span><span>' + formatMoney(l.qty * l.price) + '</span></div>').join('')
        : '<span class="pq-bundle__lines-empty">Nothing added yet.</span>';
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    if (saveEl) saveEl.textContent = '–' + formatMoney(save);
    if (saveRow) saveRow.classList.toggle('is-on', met && save > 0);
    if (totalEl) totalEl.textContent = formatMoney(totalPrice);
    if (totalMobile) totalMobile.textContent = formatMoney(totalPrice);
    if (badgeEl) {
      badgeEl.textContent = totalQty + ' of ' + target + (met ? ' ✓' : '');
      badgeEl.classList.toggle('is-met', met);
    }
    if (metaEl) metaEl.textContent = met
      ? 'Save ' + formatMoney(save) + ' · ' + totalQty + ' of ' + target
      : totalQty + ' of ' + target + ' added';

    submitBtns.forEach((btn) => {
      btn.disabled = !met;
      btn.textContent = met ? 'Add bundle to cart' : 'Add ' + remaining + ' more';
    });
  }

  async function addBundle(btn) {
    const items = [];
    state.forEach((entry, id) => {
      if (entry.qty > 0) items.push({ id: id, quantity: entry.qty });
    });
    if (!items.length) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) {
        let detail = '';
        try { const data = await res.json(); detail = data.description || data.message || ''; } catch (e) {}
        throw new Error(detail || 'add failed');
      }
      window.location.href = afterAdd === 'checkout' ? '/checkout' : '/cart';
    } catch (e) {
      btn.disabled = false;
      btn.textContent = 'Try again';
      if (msgEl && e.message && e.message !== 'add failed') msgEl.textContent = e.message;
      setTimeout(() => { btn.textContent = label; recompute(); }, 2200);
    }
  }
  submitBtns.forEach((btn) => btn.addEventListener('click', () => addBundle(btn)));

  if (bar) bar.hidden = false;
  recompute();
})();
